var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuditTable',{attrs:{"auditId":this.$route.params.categoryId,"auditType":'categories'}})
}
var staticRenderFns = []

export { render, staticRenderFns }